// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3jCZV","dragIcon":"Choice_dragIcon__2rjrg","left":"Choice_left__13wXg","input":"Choice_input__2srRw"};